import { customTextPropType } from "pages/_components/CustomText/customTextPropType";
import { arrayOf, bool, func, node, number, oneOf, oneOfType, shape, string } from "prop-types";

/*
    If you change the structure in this file, you must check:
        CustomTabs.js and ExampleTabs.js

    (This will not break any component that is using
        CustomTabs if you just add keys)
*/

/* CustomTabs Data Structure Guide */
export const fullCustomTabsPropType = {
    isPersistent: bool,
    tabsData: arrayOf(
        shape({
            text: oneOfType([string, number]),
            textType: oneOf(["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", "ARS", "USD"]),
            className: string,
            keepSpaceIfNoText: bool,

            content: node,
        }),
    ),
    className: string,
    children: node,
    setCurrentTab: func,
};

// // customTabsPropType

export const customTabsPropType = {
    isPersistent: bool,
    tabsData: arrayOf(
        shape({
            ...customTextPropType,
            content: node,
        }),
    ),
    className: string,
    children: node,
    setCurrentTab: func,
};

export const defaultCustomTabsPropType = {
    tabsData: [],
    isPersistent: false,
    className: "",
    children: [],
    setCurrentTab: () => {},
};
